import React from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Messaging from './Messaging';
import FormSetting from '../../layout/FormSetting';
import Input from '../../forms/Input';
import Select from '../../forms/Select';
import Row from '../../layout/Row';
import { HSOptions } from '../../../constants/HSOptions';
import HamQuest from '../../api/HamQuestGiver';
import { userRoles } from '../../RoleProtected';
import { HasFeature, Features } from '../../RequireFeature';

const Settings = ({ ...props }) => {
    const HasNewMaxUses = HasFeature(Features.NewMaxUses);
    const maxUseModeOptions = HSOptions.expressPass.maxUseMode.filter(o => o.value !== 'UseDefault');
    return (
        <PageBreak>
            <PageBreak tab='Settings'>
                <FormSetting
                    name='expressPassNameSettings'
                    label='Custom Program Names'
                    info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
                    text='Update'
                    getInputs={QuestRoute.expressPass.programNames}
                    onSubmit={e => HamQuest.put(QuestRoute.expressPass.programNames, e)}
                    editable
                    roles={userRoles.editProducts}
                >
                    <Input
                        label='Daily Pass'
                        name='dailyPass'
                        required
                    />
                    <Input
                        label='PrePaid Passes'
                        name='prepaidPass'
                        required
                    />
                    <Input
                        label='Fleet Passes'
                        name='fleetPass'
                        required
                    />

                </FormSetting>

                <FormSetting
                    name='expressPassSettings'
                    label='Settings'
                    info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
                    text='Update'
                    getInputs={QuestRoute.expressPass.settings}
                    callback={res => ({
                        ...res,
                        maxRedemptionsMode: res.maxRedemptions == null ? 'Unlimited' : 'Custom',
                        dailyLimitMode: res.dailyLimit == null ? 'Unlimited' : 'Custom',
                    })}
                    onSubmit={e => HamQuest.put(QuestRoute.expressPass.settings, {
                        ...e,
                        maxRedemptions: e.maxRedemptionsMode === 'Custom' ? e.maxRedemptions : 0,
                        dailyLimit: e.dailyLimitMode === 'Custom' ? e.dailyLimit : 0,
                    })}
                    editable
                    roles={userRoles.editProducts}
                >
                    {({ values }) => (
                        <>
                            <Select
                                label='Offline Processing'
                                name='offlineProcessingMode'
                                required
                            >
                                <option value='Enable'>Enable</option>
                                <option value='Disable'>Disable</option>
                            </Select>
                            <Input
                                label='Loyalty Offline Duration (hours)'
                                type='number'
                                name='loyaltyOfflineDuration'
                                min={1}
                                max={72}
                                required
                            />
                            {HasNewMaxUses ? (
                                <>
                                    <Row wrap>
                                        <Select
                                            label='Default Max Redemptions Mode'
                                            name='maxRedemptionsMode'
                                            options={maxUseModeOptions}
                                            required
                                        />
                                        {values.maxRedemptionsMode === 'Custom' ? (
                                            <Input
                                                label='Default Max Redemptions'
                                                type='number'
                                                min={1}
                                                name='maxRedemptions'
                                                required
                                            />
                                        ) : (
                                            <Input
                                                label='Default Max Redemptions'
                                                disable
                                            />
                                        )}
                                    </Row>
                                    <Row wrap>
                                        <Select
                                            label='Default Daily Limit Mode'
                                            name='dailyLimitMode'
                                            options={maxUseModeOptions}
                                            required
                                        />
                                        {values.dailyLimitMode === 'Custom' ? (
                                            <Input
                                                label='Default Daily Limit'
                                                type='number'
                                                min={0}
                                                name='dailyLimit'
                                                tooltipText='Maximum number of times in one Calendar Day that a customer can redeem.'
                                                required
                                            />
                                        ) : (
                                            <Input
                                                label='Default Daily Limit'
                                                disable
                                            />
                                        )}
                                    </Row>
                                </>
                            ) : (
                                <>
                                    <Select
                                        label='Default Max Use Period'
                                        options={HSOptions.expressPass.maxUsePeriod}
                                        name='passMaxUsePeriod'
                                        required
                                    />
                                    <Input
                                        label='Default Max Uses'
                                        type='number'
                                        min={1}
                                        name='passMaxUses'
                                        required
                                    />
                                </>
                            )}
                            <Input
                                label='Default Pass Reuse Inhibit Time (min)'
                                type='number'
                                min={0}
                                name='passReuseInhibitTime'
                                required
                            />
                            <Select
                                label='Receipt Mode'
                                options={HSOptions.expressPass.receiptMode}
                                name='receiptMode'
                                required
                            />
                        </>
                    )}
                </FormSetting>
            </PageBreak>

            <Messaging />

        </PageBreak>
    );
}

export default Settings;